import React, { useEffect } from "react";
import "./Footer.css";
import { FiChevronRight } from "react-icons/fi";
import { AiOutlineArrowUp } from "react-icons/ai";
import { Link } from "react-router-dom";
import logo from "../Assets/logocolor.png"

export default function Footer() {
  useEffect(() => {
    const backtotop = document.querySelector(".back-to-top");

    const toggleBacktotop = () => {
      if (window.scrollY > 100) {
        backtotop.classList.add("active");
      } else {
        backtotop.classList.remove("active");
      }
    };

    window.addEventListener("load", toggleBacktotop);
    window.addEventListener("scroll", toggleBacktotop);

    return () => {
      window.removeEventListener("load", toggleBacktotop);
      window.removeEventListener("scroll", toggleBacktotop);
    };
  }, []);
  return (
    <>
      <footer id="footer" className="section-bg">
        <div class="footer-top">
          <div class="container">
            <div class="row justify-content-between">
              <div class="col-lg-4 col-md-6 footer-contact">
              <Link to={"#home"}><img src={logo} alt="" className='img-fluid' /></Link>
                <p>
                  Welcome to our digital hub, where we breathe life into your
                  online vision. As a proficient website developer, we craft
                  captivating digital experiences that resonate with your
                  audience.
                </p>
              </div>

              <div class="col-lg-3 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <FiChevronRight /> <Link to="#home">Home</Link>
                  </li>
                  <li>
                    <FiChevronRight /> <Link to="#about">About us</Link>
                  </li>
                  <li>
                    <FiChevronRight /> <Link to="#portfolio">Portfolio</Link>
                  </li>
                  <li>
                    <FiChevronRight /> <Link to="#faq">Faq</Link>
                  </li>
                </ul>
              </div>

              <div class="col-lg-3 col-md-6 footer-links">
                <h4>Our Services</h4>
                <ul>
                  <li>
                    <FiChevronRight />
                    <a href="">React Development</a>
                  </li>
                  <li>
                    <FiChevronRight />
                    <a href="">Web Development</a>
                  </li>
                  <li>
                    <FiChevronRight />
                    <a href="">Backend Development</a>
                  </li>
                  <li>
                    <FiChevronRight />
                    <a href="">Data Scrapping</a>
                  </li>
                </ul>
              </div>

              {/* <div class="col-lg-3 col-md-6 footer-links">
                <h4>Our Social Networks</h4>
                <p>
                  Cras fermentum odio eu feugiat lide par naso tierra videa
                  magna derita valies
                </p>
                <div class="social-links mt-3">
                  <a href="#" class="twitter">
                    <i class="bx bxl-twitter"></i>
                  </a>
                  <a href="#" class="facebook">
                    <i class="bx bxl-facebook"></i>
                  </a>
                  <a href="#" class="instagram">
                    <i class="bx bxl-instagram"></i>
                  </a>
                  <a href="#" class="google-plus">
                    <i class="bx bxl-skype"></i>
                  </a>
                  <a href="#" class="linkedin">
                    <i class="bx bxl-linkedin"></i>
                  </a>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </footer>
      <div class="container-fluid footer-bottom d-flex align-items-center justify-content-center">
        <div class="copyright">
          &copy; Copyright{" "}
          <strong>
            <span>Acme Solutions</span>
          </strong>
          . All Rights Reserved
        </div>
      </div>
      <a
        href="#"
        class="back-to-top d-flex align-items-center justify-content-center"
      >
        <AiOutlineArrowUp />
      </a>
    </>
  );
}
